import React from "react";

import "./AboutContinued.css";

function AboutContinued() {

  return (
      <div id="about-continued">
      <span className="title">
          {"More about me"}
      </span>
      
      <div className="about-desc">
          <p>coming soon</p>
      </div>
      </div>
  );
}
  
export default AboutContinued;